module.exports = __webpack_public_path__ + "img/hkg.7428ec1c.svg";